import type { GetActivitiesSectionsQuery } from '../../lesson-builder.graphql.generated';
import { ComponentSlideshow } from '../component.constants';
import type { Pluck } from 'lib/gql/pluck';

export type ViewProps = Omit<ComponentSlideshow, '__typename'> & {
  onComponentExpand?: () => void;
};
export type EditProps = Omit<ComponentSlideshow, '__typename'> & {
  contentId: number;
};

export type SlideshowSlide = Pluck<
  Extract<
    Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
    { __typename: 'ActivitiesSlideshowComponent' }
  >,
  'slideshowImages'
>;

export const IMAGE_FIELD = 'image';
